import jsonToCsv from "./jsonToCsv";


function downloadCsv(rows, filename = "export.csv", headers) {
  const csv = jsonToCsv(rows, headers);

  // UTF-8 BOM helps Excel
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();

  a.remove();
  URL.revokeObjectURL(url);
}

export default downloadCsv;